



















import { Project, getAssignedProjects } from "@/api/project-api";
import { Component, Vue } from "vue-property-decorator";
import { statusSearchDashboard } from "@/status";
import { getStatusCode } from "@/status";

export interface SearchDashboardProjectQuery {
  keyword: string;
  status: string;
  projectCount?: number;
}

@Component({})
export default class SearchDashboardProjectBar extends Vue {
  query: SearchDashboardProjectQuery = {
    keyword: "",
    status: String(getStatusCode("施工中"))
  };
  statusSearchDashboard = statusSearchDashboard;

  public created() {
    // このやり方イマイチかも。
    // 親でもquery持って親でgetした方がいい？
    this.search();
  }

  async search() {
    let projects: Project[] = [];
    if (!this.query.status) {
      projects = await getAssignedProjects(
        this.query.keyword,
        this.query.status,
        projects.length
      );
    } else {
      projects = await getAssignedProjects(
        this.query.keyword,
        this.query.status
      );
    }
    this.$emit("search", projects, this.query.status, this.query.keyword);
  }
}
